import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

// Definicja rang turniejów i ich kolorów
export const TOURNAMENT_RANKS = {
    LOCAL: { name: 'Lokalny', color: '#8b5cf6', activeColor: '#8b5cf6', inactiveColor: 'rgba(139, 92, 246, 0.3)' },
    REGIONAL: { name: 'Regionalny', color: '#60a5fa', activeColor: '#60a5fa', inactiveColor: 'rgba(96, 165, 250, 0.3)' },
    NATIONAL: { name: 'Krajowy', color: '#f59e0b', activeColor: '#f59e0b', inactiveColor: 'rgba(245, 158, 11, 0.3)' },
    FOREIGN: { name: 'Zagraniczny', color: '#ec4899', activeColor: '#ec4899', inactiveColor: 'rgba(236, 72, 153, 0.3)' },
    INTERNATIONAL: { name: 'Międzynarodowy', color: '#4ade80', activeColor: '#4ade80', inactiveColor: 'rgba(74, 222, 128, 0.3)' },
};

const RankFilter = ({ selectedRanks, onRankChange }) => {
    const toggleRank = (rank) => {
        const newSelectedRanks = [...selectedRanks];

        if (newSelectedRanks.includes(rank)) {
            // Jeśli już jest wybrany, usuń go
            const index = newSelectedRanks.indexOf(rank);
            newSelectedRanks.splice(index, 1);
        } else {
            // Jeśli nie jest wybrany, dodaj go
            newSelectedRanks.push(rank);
        }

        onRankChange(newSelectedRanks);
    };

    return (
        <Box sx={{ mb: 3 }}>
            {/* <Typography
                variant="subtitle1"
                sx={{
                    mb: 1.5,
                    color: 'rgb(196, 181, 253)',
                    fontWeight: 500,
                    fontSize: '0.9rem'
                }}
            >
                Filtruj po randze turnieju:
            </Typography> */}

            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5,
            }}>
                {Object.entries(TOURNAMENT_RANKS).map(([key, { name, activeColor, inactiveColor }]) => {
                    const isActive = selectedRanks.includes(key);

                    return (
                        <Box
                            onClick={() => toggleRank(key)}
                            sx={{
                                backgroundColor: isActive ? activeColor : inactiveColor,
                                color: isActive ? '#000' : 'rgba(255, 255, 255, 0.7)',
                                fontWeight: isActive ? 600 : 400,
                                fontSize: '0.8rem',
                                padding: '0.4rem 0.8rem',
                                borderRadius: '0.4rem',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                boxShadow: isActive ? '0 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                }
                            }}
                        >
                            {name}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default RankFilter;